import { Anchors } from '~/modules/Anchors';
import { Accordion } from '~/modules/Accordion';
// import { SliderFooter } from '~/modules/Slider';
import { ScrollEnter } from '~/modules/ScrollEnter';
import { HeaderMemu } from '~/modules/HeaderMenu';
import { LocalNav } from '~/modules/LocalNav';
// import { Hover } from '~/modules/Hover';
// import { Tab } from '../modules/Tab';
/**
 * 実行タイミング管理
 */
export class CommonController {
  constructor() {
    this.onInit();
  }
  onInit() {
    /**
     * インスタンス生成時に実行
     */
    this.handlerLoad = () => this.onLoad();
    window.addEventListener('load', this.handlerLoad);
  }
  onLoad() {
    /**
     * window読み込み時に実行
     */
    new Accordion();
    setTimeout(() => {
      new ScrollEnter();
      new HeaderMemu();
      new LocalNav();
      new Anchors();
      // new Hover();
      // new Tab();
    }, 50);
  }
  onDestroy() {}
}
